import { useQuery } from '@tanstack/react-query';

import api from 'api';
import type { ActivityEvent } from 'types';

export const fileHistoryKeys = {
    all: ['fileHistory'] as const,
    byCase: (caseId: string) => ['fileHistory', 'case', caseId] as const,
};

/**
 * Case activity timeline for the File History modal.
 * Enabled only when a case id is present (and optionally when the modal is open).
 */
export const useFileHistory = (caseId?: string | null, options?: { enabled?: boolean }) => {
    return useQuery<ActivityEvent[]>({
        queryKey: fileHistoryKeys.byCase(caseId ?? ''),
        queryFn: async () => {
            const response = await api.fileHistory.get(caseId as string);
            const events = response.data ?? [];

            // API returns newest-first; sort defensively so the timeline stays ordered.
            return [...events].sort(
                (a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime()
            );
        },
        enabled: (options?.enabled ?? true) && Boolean(caseId),
        staleTime: 60 * 1000,
    });
};
